// components/ui/CustomModal.tsx
import React from "react";

interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <>
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-2xl shadow-lg w-[500px] p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold capitalize text-Black">{title}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-black">✖</button>
        </div>
        <div>{children}</div>
      </div>
    </div>
    </>
  );
};

export default CustomModal;
